import * as createActions from './create';
import * as fetchActions from './fetch';
import * as updateActions from './update';
import * as adoptionActions from './adoption';
import * as scorecardActions from './scorecard';

export default {
  ...createActions,
  ...fetchActions,
  ...updateActions,
  ...adoptionActions,
  ...scorecardActions,
};
